export const awardTypes = ['Category', 'Country', 'Both'] as const;
export type AwardType = typeof awardTypes[number];
